import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import App from './App';
import AuthGate from './features/auth/AuthGate';
import KanbanPage from './routes/KanbanPage';
import RotasPage from './routes/RotasPage';
import DashboardPage from './routes/DashboardPage';
import ClientesPage from './routes/ClientesPage';
import ProdutosPage from './routes/ProdutosPage';
import ConfiguracoesPage from './routes/ConfiguracoesPage';
import './styles/globals.css';

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, element: <KanbanPage /> },
      { path: 'rotas', element: <RotasPage /> },
      { path: 'dashboard', element: <DashboardPage /> },
      { path: 'clientes', element: <ClientesPage /> },
      { path: 'produtos', element: <ProdutosPage /> },
      { path: 'configuracoes', element: <ConfiguracoesPage /> },
    ],
  },
]);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthGate>
      <RouterProvider router={router} />
    </AuthGate>
  </React.StrictMode>,
);
